import { useEffect, useState } from "react";
import request from "common/request";

const useCustomerSession = ({ path, enabled }) => {
  const [session, setSession] = useState({ fetched: !enabled, clientSecret: null });

  useEffect(() => {
    if (!enabled || !path) {
      setSession({ fetched: true, clientSecret: null });
      return undefined;
    }

    let active = true;

    request
      .post(path)
      .then(response => {
        if (active) {
          setSession({
            fetched: true,
            clientSecret: response.data.customerSessionClientSecret
          });
        }
      })
      .catch(() => {
        if (active) setSession({ fetched: true, clientSecret: null });
      });

    return () => {
      active = false;
    };
  }, [enabled, path]);

  return session;
};

export default useCustomerSession;
